var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 13.5C27 17.0804 25.5777 20.5142 23.0459 23.0459C20.5142 25.5777 17.0804 27 13.5 27C9.91958 27 6.4858 25.5777 3.95406 23.0459C1.42232 20.5142 0 17.0804 0 13.5C0 9.91958 1.42232 6.4858 3.95406 3.95406C6.4858 1.42232 9.91958 0 13.5 0C17.0804 0 20.5142 1.42232 23.0459 3.95406C25.5777 6.4858 27 9.91958 27 13.5ZM15.4286 18.3214C15.4286 18.8329 15.2254 19.3235 14.8637 19.6851C14.502 20.0468 14.0115 20.25 13.5 20.25C12.9885 20.25 12.498 20.0468 12.1363 19.6851C11.7746 19.3235 11.5714 18.8329 11.5714 18.3214C11.5714 17.8099 11.7746 17.3194 12.1363 16.9577C12.498 16.596 12.9885 16.3929 13.5 16.3929C14.0115 16.3929 14.502 16.596 14.8637 16.9577C15.2254 17.3194 15.4286 17.8099 15.4286 18.3214ZM14.9464 7.71429C14.9464 7.33067 14.794 6.96276 14.5228 6.69151C14.2515 6.42025 13.8836 6.26786 13.5 6.26786C13.1164 6.26786 12.7485 6.42025 12.4772 6.69151C12.206 6.96276 12.0536 7.33067 12.0536 7.71429V12.5357C12.0536 12.9193 12.206 13.2872 12.4772 13.5585C12.7485 13.8298 13.1164 13.9821 13.5 13.9821C13.8836 13.9821 14.2515 13.8298 14.5228 13.5585C14.794 13.2872 14.9464 12.9193 14.9464 12.5357V7.71429Z",
    fill: "#FA756D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleWarning);
export default __webpack_public_path__ + "static/media/circle-warning.134ff56985e495b6782ca6bd85e5ae49.svg";
export { ForwardRef as ReactComponent };